import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { ignorepayservergamelist, deleteIgnorepayserverbygame } from "@/api/dataAll/dataAll";
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import addRechargeIgnoreServer from "./components/addRechargeIgnoreServer";
export default {
  name: "rechargeIgnoreServer",
  components: {
    addRechargeIgnoreServer: addRechargeIgnoreServer
  },
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      searchgames: [],
      tableData: [],
      value2: [],
      total: 0,
      searchData: {
        page_size: 10,
        page: 1
      }
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  activated: function activated() {},
  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick(1);
    },
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      ignorepayservergamelist(_objectSpread(_objectSpread({}, this.searchData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.status == 200) {
          var list = _this.rawData.game_mark.indexOf('royalpirates') > -1 ? _this.serverList : _this.serverListYJ;
          res.data.data.forEach(function (item) {
            var serverIdArray = item.server_ids.split(',').map(function (id) {
              return parseInt(id.trim());
            });
            var matchedServers = list.filter(function (server) {
              return serverIdArray.includes(server.serverID);
            });
            var serverNames = matchedServers.map(function (server) {
              return server.serverName;
            });
            item.serverNamesStr = serverNames.join(', ');
          });
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleServerInit: function handleServerInit() {
      if (this.rawData.game_mark.indexOf('yjfm') != -1) {
        if (!this.serverListYJ.length) {
          this.$message.error('请选择服务器渠道和是否展示测试服');
          return;
        }
      }

      this.$refs.addRechargeIgnoreServer.init();
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleteIgnorepayserverbygame({
                  game_id: _this2.rawData.game_id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.searchClick(1);

                    _this2.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};